// extracted by mini-css-extract-plugin
export default {"testingBanner":"TestingBanner_testingBanner__l8pkd"};